// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "locale-pt" + "." + "5e9963b7" + ".chunk.js";
};